<template>
  <v-menu :close-on-content-click="false" :nudge-width="300" offset-y>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip left color="black">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            color="black"
            icon
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
            @click="init()"
          >
            <v-icon size="25"> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("messanger.dash.options") }}</span>
      </v-tooltip>
    </template>

    <v-card max-width="500" max-height="550">
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-btn
            :small="$store.state.isMobile ? true : false"
            class="mx-2"
            outlined
            color="primary"
            @click="getProduct(item)"
          >
            <span class="mr-1">{{
              $t("messanger.dash.table_head.product")
            }}</span>
            <span v-if="elementExist(item, 'add')">
              <v-icon color="rgb(17, 65, 206)" size="18">
                mdi-cart-arrow-down
              </v-icon>
              <v-badge
                botton
                offset-x="5"
                offset-y="15"
                color="#008000"
                :content="countItem(item, 'add')"
                bordered
              />
            </span>
            <v-icon v-else size="18">mdi-cart-arrow-down</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn
            :small="$store.state.isMobile ? true : false"
            class="mx-2"
            outlined
            color="primary"
            @click="purchse_products(item)"
          >
            <span class="mr-1">{{
              $t("messanger.dash.table_head.product")
            }}</span>
            <span v-if="elementExist(item, 'purchse')">
              <v-icon color="rgb(17, 65, 206)" size="18">
                add mdi-shopping-search
              </v-icon>
              <v-badge
                botton
                offset-x="5"
                offset-y="15"
                color="#008000"
                :content="countItem(item, 'purchse')"
                bordered
              />
            </span>
            <v-icon v-else size="18">add mdi-shopping-search</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("messanger.dash.filters.select.Priority")
            }}</v-list-item-title>
            <v-list-item-subtitle>
              <span v-if="item.priority">High</span>
              <span v-else>Unspecified</span>
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-switch
              v-model="item.priority"
              color="purple"
              @click="change_priority"
            ></v-switch>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("messanger.dash.filters.select.Status")
            }}</v-list-item-title>
            <v-chip-group column>
              <v-chip
                v-for="(st, i) in status"
                :key="i"
                :color="st.color"
                outlined
                @click="change_status(st)"
              >
                <b>{{ $t(`messanger.dash.status.${st.value}`) }}</b>
                <v-icon v-if="st.value === select_status" class="mx-1" size="20"
                  >mdi-check</v-icon
                >
              </v-chip>
            </v-chip-group>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("messanger.dash.filters.select.status_email")
            }}</v-list-item-title>
            <v-chip-group column>
              <v-chip
                v-for="(st, i) in email_status"
                :key="i"
                :color="st.color"
                outlined
                @click="change_email_status(st)"
              >
                <b>{{ $t(`messanger.dash.email_status.${st.value}`) }}</b>
                <v-icon
                  v-if="st.value === select_email_status"
                  class="mx-1"
                  size="20"
                  >mdi-check</v-icon
                >
              </v-chip>
            </v-chip-group>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title> Conversation sujects </v-list-item-title>
            <v-chip-group
              column
              v-model="conversation_sbj_model"
              multiple
              active-class="deep-purple--text text--accent-4"
            >
              <v-chip
                v-for="(subject, i) in Conversation_subjects"
                :key="i"
                outlined
              >
                <b>
                  {{ $t(`messanger.conversation_subjects.${subject}`) }}
                </b>
                <v-icon
                  v-if="conversation_sbj_model.includes(i)"
                  class="mx-1"
                  size="20"
                >
                  mdi-check
                </v-icon>
              </v-chip>
            </v-chip-group>
            <v-row no-gutters justify="center">
              <v-col cols="6">
                <v-row dense justify="center">
                  <v-col cols="auto">
                    <v-chip
                      outlined
                      color="primary"
                      @click="ConversationSubjectSave()"
                    >
                      <b>
                        {{ $t("messanger.conversation_subjects.save") }}
                      </b>
                      <v-icon class="mx-1" size="20">mdi-check</v-icon>
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("messanger.dash.table_head.comments")
            }}</v-list-item-title>
            <v-row justify="center" align="center">
              <v-col cols="10">
                <span
                  class="d-inline-block text-truncate"
                  style="max-width: 400px"
                >
                  {{ item.AdminNote || "--" }}
                </span>
              </v-col>
              <v-col cols="auto">
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="note_change(item)"
                      v-bind="attrs"
                      v-on="on"
                      icon
                    >
                      <v-icon small color="#1141ce">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("messanger.dash.update") }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "conversation_options",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data: () => ({
    select_status: "",
    select_email_status: "",
    conversation_sbj_model: [],
    form: "",
    obj: {},
    menu: false,
    Conversation_subjects: [
      "restocking",
      "product_advice",
      "size_advice",
      "product_precisions",
      "sales",
      "return_slip",
      "returns",
      "availability_in_store",
      "delivery",
      "refund_delay",
      "delivery_delay",
      "Account_problem",
      "gift_card",
      "order_status",
      "contact",
      "problem_product_received",
      "store_info",
      "promo_code",
      "order_modification",
      "about_brand",
      "payment_method",
    ],
  }),
  computed: {
    status() {
      return this.$store.state.messages.status;
    },
    email_status() {
      return this.$store.state.messages.email_status;
    },
  },
  created() {
    console.log("created", this.item);
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.select_status = this.item.statusObj.value;
      this.select_email_status = this.item.EmailStatusObj.value;
      if (
        this.item.conversation_subject &&
        this.item.conversation_subject.length
      ) {
        this.Conversation_subjects.map((st, key) => {
          if (
            this.item.conversation_subject.includes(st) &&
            !this.conversation_sbj_model.includes(key)
          )
            this.conversation_sbj_model.push(key);
        });
        // console.log(this.conversation_sbj_model, this.item.conversation_subject);
      }
    },
    change_priority() {
      this.from = "priority";
      this.obj = {
        msg_id: this.item.i_msg,
        id: this.item.id_c,
        priority: { check: true, value: this.item.priority },
      };
      this.save();
    },
    change_status(st) {
      console.log(st.value, this.select_status);
      this.select_status = st.value;
      this.from = "status";
      this.obj = {
        msg_id: this.item.i_msg,
        id: this.item.id_c,
        status: st.value,
        status_obj: st,
      };
      this.save();
      if (
        st.value === "By email" &&
        this.item.EmailStatusObj.value !== "To answer"
      ) {
        let temp = {
          msg_id: this.item.i_msg,
          id: this.item.id_c,
          e_status: "To answer",
          status_obj: { color: "red darken-1", value: "To answer" },
        };
        this.$store.dispatch("UPDATE_MSG", temp).then((r) => {
          this.$socket.emit("UpdateAction", {
            data: temp,
            from: "e_status",
          });
          this.select_email_status = temp.e_status;
        });
      }
    },
    change_email_status(st) {
      this.select_email_status = st.value;
      this.from = "e_status";
      this.obj = {
        msg_id: this.item.i_msg,
        id: this.item.id_c,
        e_status: st.value,
        status_obj: st,
      };
      this.save();
    },
    getProduct(p) {
      let selected_product = [];
      const tmp = this.$store.state.productAdded.find(
        (element) => p.guid == element.user_id
      );
      let tmp2 = [];
      let tmp3 = [];
      if (tmp) {
        tmp2 = tmp.all_products_added_to_cart.split(",");
        tmp3 = tmp.product_date.split(",");
        for (let a = 0; a < tmp2.length; a++) {
          selected_product.push({ url: tmp2[a], date: tmp3[a] });
        }
      }
      this.$store.dispatch("setAddToCard", {
        showing: true,
        selected_product: selected_product,
      });
    },
    purchse_products(p) {
      let selected_product = [];
      const tmp = this.$store.state.productPurchase.find(
        (element) => p.guid == element.user_id
      );
      let tmp2 = [];
      let tmp3 = [];
      if (tmp) {
        tmp2 = tmp.all_products_added_to_cart.split(",");
        tmp3 = tmp.product_date.split(",");
        for (let a = 0; a < tmp2.length; a++) {
          selected_product.push({ url: tmp2[a], date: tmp3[a] });
        }
      }
      this.$store.dispatch("setPurchaseProducts", {
        showing: true,
        selected_product: selected_product,
      });
    },
    elementExist(item, action) {
      let data = undefined;
      if (action === "add")
        data = this.$store.state.productAdded.find(
          (element) => element.user_id == item.guid
        );
      else
        data = this.$store.state.productPurchase.find(
          (element) => element.user_id == item.guid
        );
      if (data) return true;
      return false;
    },
    countItem(item, action) {
      let data = undefined;
      if (action === "add")
        data = this.$store.state.productAdded.find(
          (element) => element.user_id == item.guid
        );
      else
        data = this.$store.state.productPurchase.find(
          (element) => element.user_id == item.guid
        );
      const tmp = data.all_products_added_to_cart.split(",").length;
      return tmp;
    },
    note_change(item) {
      this.$store
        .dispatch("confirmer/ask", {
          note_dialog: true,
          note: item.AdminNote,
        })
        .then((confirmation) => {
          if (confirmation) {
            this.from = "note";
            const old_note = item.AdminNote;
            this.obj = {
              msg_id: item.i_msg,
              id: item.id_c,
              text: confirmation.text,
              note: true,
            };
            if (old_note !== this.obj.text) this.save();
          }
        });
    },
    save() {
      /**
       * Properties available on `this.item` are not always the same.
       * I have to use other properties, that are also not always available.
       *
       * Keep in sync with `conversation_data` in `TBody.vue` component.
       *
       * @type {{
       *  storeId: string;
       *  id: string;
       *  conversation_id: number;
       *  guid: string;
       *  context: string;
       *  content: string;
       *  sent_at: string;
       *  status: string;
       * }}
       */
      const conversation_data = {
        storeId: this.item.store_id,
        id: this.item.id ?? this.item.receiver_id,
        conversation_id: Number(this.item.id_c),
        guid: this.item.guid,
        content: this.item.content ?? this.item.last_message,
        sent_at: this.item.sent_at,
        context: this.item.context,
        status: this.obj.status ?? this.item.status,
      };
      this.obj.conversation_data = conversation_data;

      this.$store.dispatch("setCloader", { showing: true });
      if (this.from === "status") {
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: `Message status change to ${this.obj.status_obj.value}`,
            color: this.obj.status_obj.color,
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
          this.$store.dispatch("setCloader", { showing: false });
        });
      } else if (this.from === "e_status") {
        //add the update dispatch
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: `Message status change to ${this.obj.status_obj.value}`,
            color: this.obj.status_obj.color,
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
          this.$store.dispatch("setCloader", { showing: false });
        });
      } else if (this.from === "note") {
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: `Message note updated`,
            color: "success",
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
          this.$store.dispatch("setCloader", { showing: false });
        });
      } else if (this.from === "priority") {
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: `Priority change to ${
              !this.obj.priority.value ? "Unspecified" : "High"
            }`,
            color: "success",
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
          this.item.priority = !this.item.priority;
          this.$store.dispatch("setCloader", { showing: false });
        });
      }
      this.$store.dispatch("setCloader", { showing: false });
    },
    ConversationSubjectSave() {
      const subjects = this.Conversation_subjects.filter((sb, key) => {
        if (this.conversation_sbj_model.includes(key)) {
          return sb;
        }
      });
      this.$store.dispatch("setCloader", { showing: true });
      this.$store
        .dispatch("CHANGE_CONVERSATION_SUBJECT", {
          id_c: this.item.id_c,
          subject: subjects,
        })
        .then((r) => {
          console.log(r);
          this.item.conversation_subject = subjects;
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: subjects.length
              ? "Conversation subjects change"
              : "Clean conversation status",
            color: !subjects.length ? "info" : "success",
            timeout: 2000,
          });
          this.$store.dispatch("setCloader", { showing: false });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped></style>
